import React from 'react';
import { Heart, Users, BookOpen, Sparkles } from 'lucide-react';

const values = [
  {
    icon: Heart,
    title: 'Bienveillance',
    description: "Un accompagnement empreint de douceur et de respect du rythme de chaque enfant.",
  },
  {
    icon: BookOpen,
    title: 'Rigueur professionnelle',
    description: "Des méthodes éprouvées et une formation continue pour un suivi de qualité.",
  },
  {
    icon: Users,
    title: 'Collaboration',
    description: "Un travail en étroite collaboration avec les parents, l'école et les autres professionnels.",
  },
  {
    icon: Sparkles,
    title: 'Approche individualisée',
    description: "Chaque enfant est unique, chaque accompagnement l'est aussi.",
  },
];

export const About = () => {
  return (
    <section id="a-propos" className="section-padding bg-card relative">
      <div className="max-w-7xl mx-auto container-padding">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image/Visual Side */}
          <div className="relative">
            <div className="relative aspect-square max-w-lg mx-auto">
              {/* Background decorations */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-primary/10 to-accent/10" />

              {/* Main image container */}
              <div className="absolute inset-4 rounded-2xl overflow-hidden shadow-elevated">
                <img
                  src="https://images.unsplash.com/photo-1458501534264-7d326fa0ca04?w=600&h=600&fit=crop"
                  alt="Espace thérapeutique calme et accueillant"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Floating accent card */}
              <div className="absolute -bottom-6 -right-6 bg-card rounded-2xl p-5 shadow-card max-w-xs">
                <p className="text-sm font-medium text-foreground mb-2">
                  &ldquo;L'enfant au cœur de la prise en charge&rdquo;
                </p>
                <p className="text-xs text-muted-foreground">
                  — Ma philosophie d'accompagnement
                </p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <Heart className="w-4 h-4" />
              <span>À propos</span>
            </div>

            <h2 className="font-display text-3xl sm:text-4xl font-semibold text-foreground mb-6">
              Une approche centrée sur{' '}
              <span className="text-gradient">l'enfant et sa famille</span>
            </h2>

            <div className="space-y-4 text-muted-foreground mb-8">
              <p>
                Psychomotricienne diplômée d'État, je vous accueille dans mon cabinet à Marrakech pour accompagner votre enfant dans son développement psychomoteur.
              </p>
              <p>
                Mon approche repose sur l'écoute, l'observation et la compréhension des besoins spécifiques de chaque enfant. Je crée un environnement sécurisant où l'enfant peut explorer, expérimenter et progresser à son propre rythme.
              </p>
              <p>
                Je m'engage à travailler en étroite collaboration avec vous, parents, ainsi qu'avec les enseignants et autres professionnels qui entourent votre enfant, pour un accompagnement cohérent et efficace.
              </p>
            </div>

            {/* Values Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 rounded-xl bg-background hover:bg-muted/50 transition-colors duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <value.icon className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-medium text-foreground text-sm mb-1">
                      {value.title}
                    </h3>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;